import PropTypes from 'prop-types'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Snackbar from '@mui/material/Snackbar'

const ErrorAlert = ({ title, show, message, handleClose }) => {
  const msg = Array.isArray(message) ? message : [message]
  return (
    <Snackbar open={show} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert onClose={handleClose} severity="error" variant="filled">
        <AlertTitle>
          <strong>{title} Failed!</strong>
        </AlertTitle>
        {msg.map((content, index) => {
          return <div key={index}>{content}</div>
        })}
      </Alert>
    </Snackbar>
  )
}
ErrorAlert.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  message: PropTypes.node,
  handleClose: PropTypes.func,
}

export default ErrorAlert
